import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

/**
 * enums
 */
import { CATEGOR_VALUE_TYPE } from 'src/app/core/enums/category/cate-value-types';

/**
 * 
 */
export interface ISizeHandler { title: string, value: string, toString: string }

@Pipe({
  standalone: true,
  name: 'SizeHandler',
})
export class SizeHandlerPipe implements PipeTransform {

  /**
   * Fields
   */
  /**
   * @description arg value
   */
  private _value: number = null;

  /**
   * @description sizeTitle is depend on categoryType
   */
  private _sizeTitle: string = null;  

  /**
   * 
   * @param value 
   * @param categoryType 
   * @returns 
   */
  transform(value: number, categoryType?: CATEGOR_VALUE_TYPE): ISizeHandler {

    try {

      /**
       * handler Error & null value
       */
      if (!value || value == null) `arg value is: => ${value}`;

      /**
       * 
       */
      this._value = value;

      /**
       * handler SizeTitle depend on CategoryType 
       */
      switch(categoryType) {
        case CATEGOR_VALUE_TYPE.VL:
        case CATEGOR_VALUE_TYPE.BL:
        case CATEGOR_VALUE_TYPE.PL:
        case CATEGOR_VALUE_TYPE.OFF_PLAN:

          /**
           * 
           */
          this._sizeTitle = "مساحات تبدأ من";
          break;
        default:

          /**
           * 
           */
          this._sizeTitle = "المساحة";
          break;
      }
      
      /**
       * 
       */
      return { title: this._sizeTitle, value: this._handlerSize, toString: this._toString};

    }
    catch (err: any) {
      new Error(err)
      return null
    }


  }


  /**
   * 
   */
  private get _handlerSize() {

    /**
     * handler null size
     */
    if (this._value == null) return '----';

    /**
     * handler single size
     */
    return formatNumber(this._value, 'en-US', '1.0-2').trim();

  }

  /**
   * 
   * @returns string of title + price
   */
  private get _toString(): string {
      return `${this._sizeTitle} ${this._handlerSize}`
  }  

}
